import React, { Fragment, useEffect, useState, FC } from 'react';
import { Carousel as ReactResponsiveCarousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { getNetworkDownloadSpeed } from '../../../../utils/network.utils';
import { googleClickSlideEvent, formatComponentNumber } from '../../../../utils/analytics';
import CustomCarouselDots from '../../../@shared/customCarouselDots';
import { TCarousel } from '../../types/herobanner.types';
import CarouselCut from '../carouselCut';
import HeroCarouselIndicator from '../heroCarouselIndicator';
import HeroCarouselArrow from '../heroCarouselArrow';
import HeroCarouselSlide from '../heroCarouselSlide';
import HeroCarouselScrollSymbol from '../heroCarouselScrollSymbol';

const Carousel: FC<TCarousel> = ({ items, headingTag, showCarouselOverlay, isPreview }) => {
  // when you change this change also the $interval variable in HeroCarousel > style.scss
  const interval = 10000;
  const hasMultipleSlides = items.length > 1;
  const [currentSlide, _setCurrentSlide] = useState(0);

  const setCurrentSlide = hasMultipleSlides
    ? (index: number): void => {
        if (currentSlide !== index) {
          _setCurrentSlide(index);
        }
      }
    : // eslint-disable-next-line @typescript-eslint/no-empty-function
      (): void => {
        // This is intentional
      };

  const normalizeSlideNumber = (slide) => {
    if (!items?.length) {
      return slide;
    }

    return (slide + items?.length) % items?.length;
  };

  const goNext = (): void => {
    const slide = normalizeSlideNumber(currentSlide + 1);
    setCurrentSlide(slide);
    googleClickSlideEvent(`Slide ${formatComponentNumber(slide + 1)}`, items[slide]?.title?.value);
  };

  const goPrevious = (): void => {
    const slide = normalizeSlideNumber(currentSlide - 1);
    setCurrentSlide(slide);
    googleClickSlideEvent(`Slide ${formatComponentNumber(slide + 1)}`, items[slide]?.title?.value);
  };

  const [networkSpeed, setNetworkSpeed] = useState(0);

  const videoIsPresent = items.some((item) => item.useVideo.value);

  useEffect(() => {
    if (videoIsPresent) {
      getNetworkDownloadSpeed().then((response) => {
        setNetworkSpeed(parseInt(response));
      });
    }
  }, []); // eslint-disable-line

  const carouselIndicators = (
    <div className={'controls'}>
      <HeroCarouselArrow direction={'previous'} onClick={goPrevious} />
      {(items || []).length > 5 ? (
        <CustomCarouselDots cardsCount={(items || []).length} activeCard={currentSlide + 1} hasAnimation={true} />
      ) : (
        <ul className={'controls__dots'}>
          {items.map((itemFields, index) => (
            <HeroCarouselIndicator
              baseClassName={'controls__dots__item'}
              index={index}
              key={itemFields.id}
              isSelected={index === currentSlide}
            />
          ))}
        </ul>
      )}
      <HeroCarouselArrow direction={'next'} onClick={goNext} />
    </div>
  );
  return (
    <Fragment>
      <div className="carousel-inner-wrapper">
        <ReactResponsiveCarousel
          infiniteLoop={true}
          interval={interval}
          autoPlay={true}
          onChange={setCurrentSlide}
          selectedItem={currentSlide}
          showThumbs={false}
          showArrows={false}
          showIndicators={false}
          showStatus={false}
          stopOnHover={false}
          preventMovementUntilSwipeScrollTolerance
          swipeScrollTolerance={100}
        >
          {items.map((itemFields, index) => {
            const slideInfo = { currentSlide, index, networkSpeed };
            return (
              <HeroCarouselSlide id={itemFields.id} key={itemFields.id} slideInfo={slideInfo} fields={itemFields} headingTag={headingTag} />
            );
          })}
        </ReactResponsiveCarousel>
        {hasMultipleSlides ? carouselIndicators : null}
        {showCarouselOverlay?.value && <HeroCarouselScrollSymbol />}
      </div>
      {!isPreview && <CarouselCut />}
    </Fragment>
  );
};

export default Carousel;
